import { ShoppingCart } from "lucide-react";

// Tarjeta de entrada a Venta Rápida (Retail) — presentacional.
export const VentaRapidaCard = ({ abrirVentaRapida, caja }) => (
  <div className="border border-white/10 bg-white/[0.02] p-5 min-w-0" data-testid="bloque-retail">
    <div className="flex items-center gap-2 mb-3">
      <ShoppingCart className="h-5 w-5 text-[#FFCC00]" />
      <h3 className="font-display text-lg font-black tracking-tight">Venta Rápida · Retail</h3>
    </div>
    <p className="text-white/50 text-sm mb-5" data-testid="retail-card-desc">Buscar / escanear productos<br className="hidden sm:block" /> dentro de la venta.</p>
    <button onClick={abrirVentaRapida} disabled={!caja} data-testid="retail-nueva-venta-btn"
      className="btn-hard w-full h-14 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] font-black uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-50">
      <ShoppingCart className="h-5 w-5" /> Nueva venta
    </button>
    {!caja && <p className="mt-2 text-[11px] text-white/40" data-testid="retail-sin-caja">Abre un turno para cobrar productos.</p>}
  </div>
);

export default VentaRapidaCard;
